import { DragImageProps } from '#hooks/PRIVATE_useVisDnd';

export function getDragImage<W>({ event, target }: DragImageProps<W>) {
  const container = document.createElement('div');
  const { width, height, x, y } = target.getBoundingClientRect();
  const clone = target!.cloneNode(true);
  container.appendChild(clone);
  const styles = window.getComputedStyle(target.parentElement!);
  container.style.fontSize = styles.getPropertyValue('font-size');
  container.style.fontFamily = styles.getPropertyValue('font-family');
  container.style.textAnchor = styles.getPropertyValue('text-anchor');
  container.style.dominantBaseline = styles.getPropertyValue('dominant-baseline');
  return {
    image: container,
    offSetX: event.clientX - x,
    offSetY: event.clientY - y,
    width,
    height
  };
}
